module.exports = __webpack_public_path__ + "assets/src/style/img/footer-lsc.png?cdf698a00467eb836b2490d27a6e6f4e";